import { createFileRoute } from '@tanstack/react-router';
import { categoriesQuery } from '@/features/devices/api';
import { ReferenceListPage } from '@/features/devices/pages/ReferenceListPage';

/** "Qurilma turkumi" (577:13896, create panel 585:14707). `?panel=new|<id>` opens the side panel. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/devices/categories')({
  validateSearch: (search: Record<string, unknown>): { panel?: string } => ({
    panel: typeof search.panel === 'string' && search.panel ? search.panel : undefined,
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(categoriesQuery(context.tenant.id));
  },
  component: DeviceCategoriesRoute,
});

function DeviceCategoriesRoute() {
  const { tenant } = Route.useRouteContext();
  const { panel } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReferenceListPage
      tenant={tenant}
      kind="categories"
      panel={panel}
      onPanel={(next) => void navigate({ search: (prev) => ({ ...prev, panel: next }) })}
    />
  );
}
